import { render, staticRenderFns } from "./WordpressView.vue?vue&type=template&id=02838efa&"
import script from "./WordpressView.vue?vue&type=script&lang=js&"
export * from "./WordpressView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02838efa')) {
      api.createRecord('02838efa', component.options)
    } else {
      api.reload('02838efa', component.options)
    }
    module.hot.accept("./WordpressView.vue?vue&type=template&id=02838efa&", function () {
      api.rerender('02838efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/wordpress/WordpressView.vue"
export default component.exports